import React, { useEffect } from "react";
import gameImg from '../../Img/game_img.jpg'
import { MdDoubleArrow } from "react-icons/md";
import { Link } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaRocket } from "react-icons/fa";

const AboutHeroSection = () => {

 useEffect(() => {
  import("aos").then((AOS) => {
    AOS.default.init({
      duration: 500,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
    });
  });
}, []);

  return (
    <section 
      className="relative lg:px-8 text-white sm:py-16 py-10 overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-800"
    >
      <div className="container mx-auto px-4">
        
        <div className="flex xl:flex-nowrap flex-wrap flex-row-reverse items-center gap-10 lg:gap-16">
          
          <div 
            className="xl:w-3/5 w-full"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <div className="md:ps-6 lg:ps-10">
              <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold leading-tight flex flex-wrap items-center gap-3 mb-6" data-aos="zoom-in" data-aos-delay="400">
                Our Story &{" "}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
                  Mission
                </span>
                <FaRocket className="text-cyan-400 hover:-translate-y-1 transition-transform duration-300" />
              </h2>

              {/* 🚀 NATURAL HUMAN-WRITTEN CONTENT FOR LOW CONTENT QUALITY FIX */}
              <div className="space-y-5 text-gray-300 sm:text-lg text-[16px] leading-relaxed font-light mb-8">
                <p data-aos="fade-up" data-aos-delay="500">
                  Game Zone Hub was born out of frustration. We were tired of wanting to play a quick game online, only to be hit with aggressive paywalls, confusing download links, and sites that felt unsafe. We knew there had to be a better way to enjoy casual gaming on the internet.
                </p>
                <p data-aos="fade-up" data-aos-delay="600">
                  So, we built this platform. Our goal is simple: to give you a safe, fast, and completely free place to play games. By using modern web technology, we make sure that every game on our site runs smoothly in your browser, whether you are taking a break on your laptop or killing time on your phone. No installations, no hidden fees—just pure entertainment.
                </p>
              </div>

              {/* 🚀 SIMPLIFIED CHECKMARKS WITH NATURAL DESCRIPTIONS */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10" data-aos="fade-up" data-aos-delay="700">
                  <div className="flex flex-wrap items-start gap-3 text-gray-200 bg-white/5 p-4 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                      <IoCheckmarkCircle className="text-green-500 mt-1 shrink-0" size={24} /> 
                      <div>
                        <span className="font-bold text-white block mb-1">Safe & Secure</span>
                        <span className="text-sm text-gray-400 leading-snug">Because games run in your browser, there is zero risk of downloading viruses.</span>
                      </div>
                  </div>
                  <div className="flex flex-wrap items-start gap-3 text-gray-200 bg-white/5 p-4 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                      <IoCheckmarkCircle className="text-cyan-500 mt-1 shrink-0" size={24} /> 
                      <div>
                        <span className="font-bold text-white block mb-1">Instant Play</span>
                        <span className="text-sm text-gray-400 leading-snug">Skip the loading screens. Click a game and start playing immediately.</span>
                      </div>
                  </div>
                  <div className="flex flex-wrap items-start gap-3 text-gray-200 bg-white/5 p-4 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                      <IoCheckmarkCircle className="text-purple-500 mt-1 shrink-0" size={24} /> 
                      <div>
                        <span className="font-bold text-white block mb-1">Works on Mobile</span>
                        <span className="text-sm text-gray-400 leading-snug">Enjoy your favorite games on your smartphone or tablet with touch controls.</span>
                      </div>
                  </div>
                  <div className="flex flex-wrap items-start gap-3 text-gray-200 bg-white/5 p-4 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                      <IoCheckmarkCircle className="text-yellow-500 mt-1 shrink-0" size={24} /> 
                      <div>
                        <span className="font-bold text-white block mb-1">Fresh Content</span>
                        <span className="text-sm text-gray-400 leading-snug">We test and add new, high-quality games to our collection regularly.</span>
                      </div>
                  </div>
              </div>
   
              <div 
                className="flex flex-row gap-4 md:justify-start"
                data-aos="fade-up"
                data-aos-delay="800"
              >
                <Link 
                  to="/games"
                  aria-label="See all the free online games we offer"
                  className="px-8 sm:py-4 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-full font-bold text-lg flex items-center gap-3 hover:from-blue-500 hover:to-cyan-400 transition-all duration-300 shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:shadow-[0_0_30px_rgba(59,130,246,0.6)] transform hover:scale-105"
                >
                  Start Playing <MdDoubleArrow size={22} />
                </Link>
              </div>
            </div>
          </div>

          <div 
            className="relative xl:w-2/5 w-full md:mt-0 sm:mt-10"
            data-aos="zoom-in-up"
            data-aos-delay="500"
          >
            <div className="rounded-3xl overflow-hidden shadow-[0_10px_35px_rgba(0,150,255,0.25)] border border-white/10 hover:shadow-[0_20px_45px_rgba(0,150,255,0.45)] transition-all duration-500 hover:scale-[1.03] group">
              <picture>
               <source
                  srcSet={gameImg}
                  type="image/jpg"
                />
                <img
                src={gameImg}
                alt="A collection of fun, free browser games at Game Zone Hub"
                title="Game Zone Hub Games"
                className="object-cover w-full h-full cursor-pointer transition-transform duration-700 group-hover:scale-110"
                fetchpriority="high"
                decoding="async"
                />
              </picture>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
            </div>

            <div className="absolute -z-10 top-10 -left-10 w-80 h-80 bg-blue-600 rounded-full mix-blend-screen filter blur-[80px] opacity-30 animate-pulse"></div>
            <div className="absolute -z-10 bottom-10 -right-10 w-80 h-80 bg-purple-600 rounded-full mix-blend-screen filter blur-[80px] opacity-30 animate-pulse" style={{animationDelay: '1s'}}></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutHeroSection;